import type { NmoUserApiResponse } from '@candyland/generic/shared/model-nmo';
// import { UserAccountProfileModel } from '@candyland/generic/shared/tt-com-anmeldung/models';
import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';
import * as fromAuth from './auth-v2.actions';

export const AUTH_FEATURE_KEY_V2 = 'auth';

export interface AuthStateV2 {
  error?: any;
  userData: NmoUserApiResponse | null;
  isLoggedIn: boolean | null;
}

export interface AuthPartialStateV2 {
  readonly [AUTH_FEATURE_KEY_V2]: AuthStateV2;
}

const _authReducer = createReducer(
  void 0,
  on(fromAuth.initialLoginCheckV2.notLoggedIn, () => ({ userData: null, isLoggedIn: false })),
  on(fromAuth.initialLoginCheckV2.loggedIn, () => ({
    userData: null,
    isLoggedIn: true,
  })),
  on(fromAuth.usersApiV2.loadUserDataSuccess, (state, { userData }) => ({
    ...state,
    userData,
    isLoggedIn: true,
    error: null,
  })),
  on(fromAuth.usersApiV2.loadUserDataFailure, (state, { error }) => ({ ...state, error })),
  on(fromAuth.usersApiV2.loginCheckWasPositive, (_, { userData }) => ({
    userData,
    isLoggedIn: true,
  })),
  on(fromAuth.usersApiV2.loginCheckWasNegative, fromAuth.removeUserFromStoreV2, () => ({
    userData: null,
    isLoggedIn: false,
  })),
  on(fromAuth.usersApiV2.loginCheckError, (state, { error }) => ({ ...state, error }))
);

export function authReducerV2(state: AuthStateV2, action: Action) {
  return _authReducer(state, action);
}
